<div class="line my-3">
  <h5 class="username my-1">{{ usernameString }}</h5>
  @if (!content()) {
    <p-progressSpinner
      styleClass="w-2rem h-2rem"
      strokeWidth="5"
    />
  }
  <markdown
    class="markdown my-1 line-height-3"
    [data]="content()!.toString()"
    #markdown
  />
  <div class="buttons my-1">
    @if (content()) {
      <button
        class="mr-3"
        type="button"
        pTooltip="Copier le message"
        i18n-pTooltip="@@chat_line_copy_tooltip"
        tooltipPosition="bottom"
        (click)="copyHtmlOfElement(markdown.element.nativeElement)"
      >
        <i class="pi pi-copy"></i>
      </button>
    }
  </div>
</div>
